import { isNil, isString } from './assertions';
export function normalizeRoot(rootOrSelector) {
    if (isString(rootOrSelector)) {
        var rootOrNull = document.querySelector(rootOrSelector);
        if (isNil(rootOrNull)) {
            throw new Error("Couldn't find any root element matching selector '" + rootOrSelector + "'.");
        }
        return rootOrNull;
    }
    return rootOrSelector;
}
